import dayjs from 'dayjs'

import { splitChecklistStructureAndDetails, trackChecklistCreation } from '@/common/utils/checklist'
import { SurveyId, surveyCanBeTriggered, triggerSurvey } from '@/plugins/satismeter'
import service from '@/services/checklist.service'
import documentsService from '@/services/documents.service'

import {
  ADD_ALL_ITEMS_TO_SELECTION,
  ADD_TASK_TO_SELECTION,
  ADD_SECTION_CHILDREN_TO_SELECTION,
  ADD_SECTION_TO_SELECTION,
  CLEAR_ITEMS_SELECTION,
  CLOSE_CHECKLIST_SHARE_BY_EMAIL_PANE,
  CLOSE_SAVE_CHECKLIST_DIALOG,
  CLOSE_IMPORT_CHECKLIST_DIALOG,
  CLOSE_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG,
  COLLAPSE_ALL_SECTIONS,
  COLLAPSE_SECTION,
  CONTACT_RESPONSIBLE,
  CREATE_TASK,
  CREATE_SECTION,
  DELETE_FILDERS,
  DELETE_SAVED_CHECKLIST,
  SHARE_SAVED_CHECKLIST,
  RENAME_SAVED_CHECKLIST,
  DELETE_CHECKLIST_DOUBLE_VALIDATION,
  DELETE_TABLE_SELECTION,
  DELETE_TASK,
  DELETE_TASK_COMMENT,
  DELETE_SECTION,
  DUPLICATE_TASK,
  EDIT_TASK,
  EDIT_SECTION,
  EXPAND_ALL_SECTIONS,
  EXPAND_SECTION,
  GET_ATTACHED_FILE_VERSIONS,
  POST_ATTACHED_FILE_VERSION,
  SHARE_TASKS,
  SAVE_CHECKLIST,
  UPDATE_CHECKLIST,
  GET_SAVED_CHECKLISTS,
  GET_SELF_SAVED_CHECKLISTS,
  GET_SAVED_CHECKLIST_PREVIEW,
  GET_LEXISNEXIS_CHECKLISTS,
  GET_LEXISNEXIS_CHECKLIST_PREVIEW,
  IMPORT_CHECKLIST_FROM_CLOSD,
  IMPORT_CHECKLIST_FROM_EXCEL,
  GET_TASK_COMMENTS,
  POST_TASK_COMMENT,
  GET_TASK_STATUS_CATEGORIES,
  GET_TASK_DETAILS,
  GET_CHECKLIST,
  GET_CHECKLIST_DETAILS,
  GET_CHECKLIST_LAST_UPDATES,
  GET_TASK_FOLDER,
  MOVE_FILDERS,
  OPEN_SAVE_CHECKLIST_DIALOG,
  OPEN_CHECKLIST_SHARE_BY_EMAIL_PANE,
  MOVE_ITEMS,
  REMOVE_TASK_FROM_SELECTION,
  REMOVE_SECTION_CHILDREN_FROM_SELECTION,
  REMOVE_SECTION_FROM_SELECTION,
  RENAME_ATTACHED_FILE,
  SHARE_ATTACHED_FILES,
  SHARE_CHECKLIST_BY_EMAIL,
  POST_STATUS,
  DELETE_SEARCH_RESULTS,
  GET_SEARCH_RESULTS,
  GET_GLOBAL_TASK_FOLDER,
  DOWNLOAD_TODO_FILES,
  CHANGE_CHECKLIST_VERSIONING_PANE_TAB,
  CLOSE_CHECKLIST_VERSIONING_PANE,
  SET_CHECKLIST_VERSIONING_PANE,
  CHANGE_CHECKLIST_PANE_TAB,
  CHANGE_CHECKLIST_PANE_TASKS,
  CLOSE_CHECKLIST_PANE,
  OPEN_CHECKLIST_PANE,
  GET_PANE_TASK_DETAILS,
  UPDATE_TASK_RIGHTS,
} from './action_types'
import {
  REMOVE_FROM_EXPAND_TASK_AFTER_DELETE,
  REMOVE_TASK_COMMENTS_PENDING,
  REMOVE_PANE_TASK_DETAILS_PENDING,
  REMOVE_TASK_RIGHTS_PENDING,
  REMOVE_TASK_FOLDER_PENDING,
  SET_ATTACHED_FILE_VERSIONS,
  SET_ATTACHED_FILE_VERSIONS_ERROR,
  SET_ATTACHED_FILE_VERSIONS_PENDING,
  SET_CHECKLIST_STRUCTURE,
  SET_CHECKLIST_PENDING,
  SET_CHECKLIST_DETAILS_PENDING,
  SET_CONTACT_RESPONSIBLE_ERROR,
  SET_CONTACT_RESPONSIBLE_PENDING,
  SET_CREATE_TASK_ERROR,
  SET_CREATE_TASK_PENDING,
  SET_CREATE_SECTION_PENDING,
  SET_DELETE_FILDERS_ERROR,
  SET_DELETE_FILDERS_PENDING,
  SET_DELETE_SAVED_CHECKLIST_PENDING,
  SET_DELETE_SAVED_CHECKLIST_ERROR,
  SET_SHARE_SAVED_CHECKLIST_PENDING,
  SET_SHARE_SAVED_CHECKLIST_ERROR,
  SET_RENAME_SAVED_CHECKLIST_PENDING,
  SET_RENAME_SAVED_CHECKLIST_ERROR,
  SET_SELECTED_SAVED_CHECKLIST,
  SET_DELETE_TABLE_SELECTION_ERROR,
  SET_DELETE_CHECKLIST_DOUBLE_VALIDATION_PENDING,
  SET_DELETE_TABLE_SELECTION_PENDING,
  SET_DELETE_TASK_COMMENT_ERROR,
  SET_DELETE_TASK_COMMENT_PENDING,
  SET_DELETE_TASK_ERROR,
  SET_DELETE_TASK_PENDING,
  SET_DELETE_SECTION_PENDING,
  SET_DUPLICATE_TASK_ERROR,
  SET_DUPLICATE_TASK_PENDING,
  SET_EDIT_TASK,
  SET_EDIT_TASK_PENDING,
  SET_EDIT_SECTION,
  SET_EDIT_SECTION_PENDING,
  SET_IMPORT_CHECKLIST_FROM_CLOSD_ERROR,
  SET_IMPORT_CHECKLIST_FROM_CLOSD_PENDING,
  SET_IMPORT_CHECKLIST_FROM_EXCEL_PENDING,
  SET_LAST_TASK_ADDED,
  SET_LAST_SECTION_ADDED,
  SET_MOVE_FILDERS_ERROR,
  SET_MOVE_FILDERS_PENDING,
  SET_CHECKLIST_SHARE_BY_EMAIL_PANE,
  SET_POST_ATTACHED_FILE_VERSIONS_ERROR,
  SET_POST_ATTACHED_FILE_VERSIONS_PENDING,
  SET_MOVE_ITEMS_PENDING,
  SET_POST_TASK_COMMENT_ERROR,
  SET_POST_TASK_COMMENT_PENDING,
  SET_TASK_DETAILS,
  SET_TASK_DETAILS_PENDING,
  SET_RENAME_ATTACHED_FILE_ERROR,
  SET_RENAME_ATTACHED_FILE_PENDING,
  SET_SAVED_CHECKLISTS,
  SET_SAVED_CHECKLISTS_ERROR,
  SET_SAVED_CHECKLISTS_PENDING,
  SET_SELF_SAVED_CHECKLISTS_PENDING,
  SET_SELF_SAVED_CHECKLISTS,
  SET_SAVED_CHECKLIST_PREVIEW_PENDING,
  SET_SAVED_CHECKLIST_PREVIEW,
  SET_SAVED_CHECKLIST_PREVIEW_ERROR,
  SET_LEXISNEXIS_CHECKLISTS_PENDING,
  SET_LEXISNEXIS_CHECKLISTS,
  SET_LEXISNEXIS_CHECKLISTS_ERROR,
  SET_LEXISNEXIS_CHECKLIST_PREVIEW_PENDING,
  SET_LEXISNEXIS_CHECKLIST_PREVIEW,
  SET_LEXISNEXIS_CHECKLIST_PREVIEW_ERROR,
  SET_SAVE_CHECKLIST_DIALOG_IS_OPEN,
  SET_IMPORT_CHECKLIST_DIALOG_IS_OPEN,
  SET_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG_IS_OPEN,
  SET_SAVE_CHECKLIST_ERROR,
  SET_SAVE_CHECKLIST_PENDING,
  SET_UPDATE_CHECKLIST_PENDING,
  SET_SELECTED_TASKS,
  SET_SELECTED_SECTIONS,
  SET_SHARE_ATTACHED_FILES_ERROR,
  SET_SHARE_ATTACHED_FILES_PENDING,
  SET_SHARE_CHECKLIST_BY_EMAIL_PENDING,
  SET_POST_STATUS_PENDING,
  SET_POST_STATUS_ERROR,
  SET_SHARE_TASKS_ERROR,
  SET_SHARE_TASKS_PENDING,
  SET_TASK_COMMENTS_ERROR,
  SET_TASK_COMMENTS_PENDING,
  SET_PANE_TASK_DETAILS_PENDING,
  SET_TASK_RIGHTS_PENDING,
  SET_TASK_FOLDER,
  SET_TASK_FOLDER_ERROR,
  SET_TASK_FOLDER_PENDING,
  REMOVE_TASK_DETAILS_PENDING,
  SET_TASK_STATUS_CATEGORIES_PENDING,
  SET_TASK_STATUS_CATEGORIES_ERROR,
  SET_TASK_STATUS_CATEGORIES,
  REMOVE_POST_TASK_COMMENT_PENDING,
  REMOVE_DELETE_TASK_COMMENT_PENDING,
  SET_SECTIONS_EXPAND_STATE,
  SET_SEARCH_QUERY,
  SET_GLOBAL_TASK_FOLDER,
  SET_GLOBAL_TASK_FOLDER_PENDING,
  SET_DOWNLOAD_TODO_FILES_PENDING,
  SET_CHECKLIST_VERSIONING_PANE_TAB,
  TOGGLE_CHECKLIST_VERSIONING_PANE,
  SET_CHECKLIST_PANE,
  SET_CHECKLIST_PANE_TAB,
  SET_CHECKLIST_PANE_TASKS,
  SET_CHECKLIST_TASKS_DETAILS,
  SET_CHECKLIST_SECTIONS_DETAILS,
  SET_CHECKLIST_LAST_UPDATE_DATE,
  REMOVE_CHECKLIST_SECTIONS_DETAILS,
  REMOVE_CHECKLIST_TASKS_DETAILS,
  SET_CHECKLIST_PRISTINE,
} from './mutation_types'

export const actions = {
  async [DOWNLOAD_TODO_FILES] ({ commit }, { mnemo, data }) {
    commit(SET_DOWNLOAD_TODO_FILES_PENDING, true)
    try {
      const response = await service.downloadTodoFiles(mnemo, data)
      return response.data
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      commit(SET_DOWNLOAD_TODO_FILES_PENDING, false)
    }
  },
  async [GET_GLOBAL_TASK_FOLDER] ({ commit }, mnemo) {
    commit(SET_GLOBAL_TASK_FOLDER_PENDING, true)
    try {
      const { data } = await service.getAllTodoFiles(mnemo)
      commit(SET_GLOBAL_TASK_FOLDER, data.files)
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      commit(SET_GLOBAL_TASK_FOLDER_PENDING, false)
    }
  },
  async [POST_STATUS] ({ commit }, { mnemo, data }) {
    commit(SET_POST_STATUS_PENDING, true)
    try {
      const response = await service.postStatus(mnemo, data)
      commit(SET_TASK_STATUS_CATEGORIES, response.data.statuses)
      return !!response.data.success
    } catch (error) {
      commit(SET_POST_STATUS_ERROR, error)
      throw error
    } finally {
      commit(SET_POST_STATUS_PENDING, false)
    }
  },
  async [DUPLICATE_TASK] ({ commit }, { mnemo, taskId }) {
    commit(SET_DUPLICATE_TASK_PENDING, true)
    try {
      await service.duplicateTask(mnemo, taskId)
    } catch (error) {
      commit(SET_DUPLICATE_TASK_ERROR, error)
      throw error
    } finally {
      commit(SET_DUPLICATE_TASK_PENDING, false)
    }
  },
  async [CONTACT_RESPONSIBLE] ({ commit }, { mnemo, taskId, data }) {
    commit(SET_CONTACT_RESPONSIBLE_PENDING, true)
    try {
      await service.contactResponsible(mnemo, taskId, data)
    } catch (error) {
      commit(SET_CONTACT_RESPONSIBLE_ERROR, error)
      throw error
    } finally {
      commit(SET_CONTACT_RESPONSIBLE_PENDING, false)
    }
  },
  async [DELETE_TASK] ({ commit }, { mnemo, taskId }) {
    commit(SET_DELETE_TASK_PENDING, true)
    try {
      await service.deleteTask(mnemo, taskId)
    } catch (error) {
      commit(SET_DELETE_TASK_ERROR, error)
      throw error
    } finally {
      commit(SET_DELETE_TASK_PENDING, false)
    }
  },
  async [DELETE_CHECKLIST_DOUBLE_VALIDATION] ({ commit }, { mnemo, data }) {
    commit(SET_DELETE_CHECKLIST_DOUBLE_VALIDATION_PENDING, true)
    try {
      await service.deleteChecklistDoubleValidation(mnemo, data)
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      commit(SET_DELETE_CHECKLIST_DOUBLE_VALIDATION_PENDING, false)
    }
  },
  async [DELETE_TABLE_SELECTION] ({ commit, dispatch, getters, rootGetters }) {
    commit(SET_DELETE_TABLE_SELECTION_PENDING, true)

    const roomMnemo = rootGetters['room/roomMnemo']
    const taskIds = getters.selectedTasks.map(task => task.id)
    const sectionIds = getters.selectedSections.map(section => section.id)

    try {
      await service.deleteChecklistItems(roomMnemo, { taskIds, sectionIds })
      dispatch(CLEAR_ITEMS_SELECTION)
      dispatch(GET_CHECKLIST, roomMnemo)
    } catch (error) {
      commit(SET_DELETE_TABLE_SELECTION_ERROR, error)
      throw error
    } finally {
      commit(SET_DELETE_TABLE_SELECTION_PENDING, false)
    }
  },
  async [MOVE_ITEMS] ({ commit }, { mnemo, data }) {
    commit(SET_MOVE_ITEMS_PENDING, true)
    try {
      await service.moveItems(mnemo, data)
    } finally {
      commit(SET_MOVE_ITEMS_PENDING, false)
    }
  },
  async [POST_ATTACHED_FILE_VERSION] ({ commit }, { mnemo, documentId, data }) {
    commit(SET_POST_ATTACHED_FILE_VERSIONS_PENDING, true)
    try {
      await service.postAttachedFileVersion(mnemo, documentId, data)
    } catch (error) {
      commit(SET_POST_ATTACHED_FILE_VERSIONS_ERROR, error)
      throw error
    } finally {
      commit(SET_POST_ATTACHED_FILE_VERSIONS_PENDING, false)
    }
  },
  async [GET_ATTACHED_FILE_VERSIONS] ({ commit }, { mnemo, fileId }) {
    commit(SET_ATTACHED_FILE_VERSIONS_PENDING, true)
    try {
      const response = await service.getAttachedFileVersions(mnemo, fileId)
      commit(SET_ATTACHED_FILE_VERSIONS, response.data)
    } catch (error) {
      commit(SET_ATTACHED_FILE_VERSIONS_ERROR, error)
      throw error
    } finally {
      commit(SET_ATTACHED_FILE_VERSIONS_PENDING, false)
    }
  },
  async [RENAME_ATTACHED_FILE] ({ commit }, { mnemo, fileId, data }) {
    commit(SET_RENAME_ATTACHED_FILE_PENDING, true)
    try {
      await service.renameAttachedFile(mnemo, fileId, data)
    } catch (error) {
      commit(SET_RENAME_ATTACHED_FILE_ERROR, error)
      throw error
    } finally {
      commit(SET_RENAME_ATTACHED_FILE_PENDING, false)
    }
  },
  async [DELETE_FILDERS] ({ commit }, { mnemo, data }) {
    commit(SET_DELETE_FILDERS_PENDING, true)
    try {
      await service.deleteFilders(mnemo, data)
    } catch (error) {
      commit(SET_DELETE_FILDERS_ERROR, error)
      throw error
    } finally {
      commit(SET_DELETE_FILDERS_PENDING, false)
    }
  },
  async [MOVE_FILDERS] ({ commit }, { mnemo, data }) {
    commit(SET_MOVE_FILDERS_PENDING, true)
    try {
      await service.moveFilders(mnemo, data)
    } catch (error) {
      commit(SET_MOVE_FILDERS_ERROR, error)
      throw error
    } finally {
      commit(SET_MOVE_FILDERS_PENDING, false)
    }
  },
  async [SHARE_ATTACHED_FILES] ({ commit }, { mnemo, data }) {
    commit(SET_SHARE_ATTACHED_FILES_PENDING, true)
    try {
      await service.shareAttachedFiles(mnemo, data)
    } catch (error) {
      commit(SET_SHARE_ATTACHED_FILES_ERROR, error)
      throw error
    } finally {
      commit(SET_SHARE_ATTACHED_FILES_PENDING, false)
    }
  },
  async [GET_TASK_FOLDER] ({ commit, state }, { mnemo, folderId, queryObject }) {
    commit(SET_TASK_FOLDER_PENDING, folderId)
    try {
      const response = await documentsService.getDocumentsById(mnemo, folderId, queryObject)
      commit(SET_TASK_FOLDER, response.data)
    } catch (error) {
      commit(SET_TASK_FOLDER_ERROR, error)
      throw error
    } finally {
      commit(REMOVE_TASK_FOLDER_PENDING,
        state.taskFolderPendingIds.indexOf(folderId))
    }
  },
  async [GET_TASK_DETAILS] ({ commit, state }, { mnemo, taskId }) {
    commit(SET_TASK_DETAILS_PENDING, taskId)
    try {
      const response = await service.getTaskDetails(mnemo, taskId)
      commit(SET_TASK_DETAILS, response.data)
    } finally {
      commit(REMOVE_TASK_DETAILS_PENDING,
        state.taskDetailsPendingIds.indexOf(taskId))
    }
  },
  async [SHARE_TASKS] ({ commit }, { mnemo, data }) {
    commit(SET_SHARE_TASKS_PENDING, true)
    try {
      await service.shareTasks(mnemo, data)
    } catch (error) {
      commit(SET_SHARE_TASKS_ERROR, error)
      throw error
    } finally {
      commit(SET_SHARE_TASKS_PENDING, false)
    }
  },
  async [DELETE_SAVED_CHECKLIST] ({ commit }, { todoListId }) {
    commit(SET_DELETE_SAVED_CHECKLIST_PENDING, true)
    try {
      await service.deleteSavedChecklist(todoListId)
      commit(SET_SELECTED_SAVED_CHECKLIST, null)
    } catch (error) {
      commit(SET_DELETE_SAVED_CHECKLIST_ERROR, error)
      console.error(error)
      throw error
    } finally {
      commit(SET_DELETE_SAVED_CHECKLIST_PENDING, false)
    }
  },
  async [SHARE_SAVED_CHECKLIST] ({ commit }, { todoListId, data }) {
    commit(SET_SHARE_SAVED_CHECKLIST_PENDING, true)
    try {
      await service.shareSavedChecklist(todoListId, data)
    } catch (error) {
      commit(SET_SHARE_SAVED_CHECKLIST_ERROR, error)
      console.error(error)
      throw error
    } finally {
      commit(SET_SHARE_SAVED_CHECKLIST_PENDING, false)
    }
  },
  async [RENAME_SAVED_CHECKLIST] ({ commit }, { todoListId, name }) {
    commit(SET_RENAME_SAVED_CHECKLIST_PENDING, true)
    try {
      await service.renameSavedChecklist(todoListId, name)
    } catch (error) {
      commit(SET_RENAME_SAVED_CHECKLIST_ERROR, error)
      console.error(error)
      throw error
    } finally {
      commit(SET_RENAME_SAVED_CHECKLIST_PENDING, false)
    }
  },
  async [IMPORT_CHECKLIST_FROM_CLOSD] ({ commit, state }, { mnemo, data }) {
    commit(SET_IMPORT_CHECKLIST_FROM_CLOSD_PENDING, true)
    try {
      await service.importChecklistFromClosd(mnemo, data)
      trackChecklistCreation(state, mnemo)
    } catch (error) {
      commit(SET_IMPORT_CHECKLIST_FROM_CLOSD_ERROR, error)
      console.error(error)
      throw error
    } finally {
      commit(SET_IMPORT_CHECKLIST_FROM_CLOSD_PENDING, false)
    }
  },
  async [IMPORT_CHECKLIST_FROM_EXCEL] ({ commit, dispatch, state }, { mnemo, data }) {
    commit(SET_IMPORT_CHECKLIST_FROM_EXCEL_PENDING, true)
    try {
      await service.importChecklistFromExcel(mnemo, data)
      trackChecklistCreation(state, mnemo)
      
      dispatch(GET_CHECKLIST, mnemo)
    } finally {
      commit(SET_IMPORT_CHECKLIST_FROM_EXCEL_PENDING, false)
    }
  },
  async [GET_SAVED_CHECKLISTS] ({ commit }) {
    commit(SET_SAVED_CHECKLISTS_PENDING, true)
    commit(SET_SAVED_CHECKLISTS_ERROR, null)
    try {
      const response = await service.getSavedChecklists()
      commit(SET_SAVED_CHECKLISTS, response.data)
    } catch (error) {
      commit(SET_SAVED_CHECKLISTS_ERROR, error)
      console.error(error)
      throw error
    } finally {
      commit(SET_SAVED_CHECKLISTS_PENDING, false)
    }
  },
  async [GET_SELF_SAVED_CHECKLISTS] ({ commit }) {
    commit(SET_SELF_SAVED_CHECKLISTS_PENDING, true)
    try {
      const response = await service.getSelfSavedChecklists()
      commit(SET_SELF_SAVED_CHECKLISTS, response.data.data)
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      commit(SET_SELF_SAVED_CHECKLISTS_PENDING, false)
    }
  },
  async [GET_SAVED_CHECKLIST_PREVIEW] ({ commit }, { todoListId }) {
    commit(SET_SAVED_CHECKLIST_PREVIEW_PENDING, true)
    commit(SET_SAVED_CHECKLIST_PREVIEW_ERROR, null)
    try {
      const response = await service.getSavedChecklistPreview(todoListId)
      if (response?.data?.titles) {
        commit(SET_SAVED_CHECKLIST_PREVIEW, response.data.titles)
      }
    } catch (error) {
      commit(SET_SAVED_CHECKLIST_PREVIEW_ERROR, error)
      console.error(error)
      throw error
    } finally {
      commit(SET_SAVED_CHECKLIST_PREVIEW_PENDING, false)
    }
  },
  async [GET_LEXISNEXIS_CHECKLISTS] ({ commit }) {
    commit(SET_LEXISNEXIS_CHECKLISTS_PENDING, true)
    commit(SET_LEXISNEXIS_CHECKLISTS_ERROR, null)
    try {
      const response = await service.getLexisNexisChecklists()
      if (response?.data?.checklists) {
        commit(SET_LEXISNEXIS_CHECKLISTS, response.data.checklists)
      }
    } catch (error) {
      commit(SET_LEXISNEXIS_CHECKLISTS_ERROR, error)
      console.error(error)
      throw error
    } finally {
      commit(SET_LEXISNEXIS_CHECKLISTS_PENDING, false)
    }
  },
  async [GET_LEXISNEXIS_CHECKLIST_PREVIEW] ({ commit }, { todoListId }) {
    commit(SET_LEXISNEXIS_CHECKLIST_PREVIEW_PENDING, true)
    commit(SET_LEXISNEXIS_CHECKLIST_PREVIEW_ERROR, null)
    try {
      const response = await service.getLexisNexisChecklistPreview(todoListId)
      if (response?.data?.titles) {
        commit(SET_LEXISNEXIS_CHECKLIST_PREVIEW, response.data.titles)
      }
    } catch (error) {
      commit(SET_LEXISNEXIS_CHECKLIST_PREVIEW_ERROR, error)
      console.error(error)
      throw error
    } finally {
      commit(SET_LEXISNEXIS_CHECKLIST_PREVIEW_PENDING, false)
    }
  },
  async [SAVE_CHECKLIST] ({ commit }, { mnemo, data }) {
    commit(SET_SAVE_CHECKLIST_PENDING, true)
    try {
      await service.saveChecklist(mnemo, data)
    } catch (error) {
      console.error(error)
      commit(SET_SAVE_CHECKLIST_ERROR, error)
      throw error
    } finally {
      commit(SET_SAVE_CHECKLIST_PENDING, false)
    }
  },
  async [UPDATE_CHECKLIST] ({ commit }, { mnemo, taskId, data }) {
    commit(SET_UPDATE_CHECKLIST_PENDING, true)
    try {
      await service.updateChecklist(mnemo, taskId, data)
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      commit(SET_UPDATE_CHECKLIST_PENDING, false)
    }
  },
  async [DELETE_TASK_COMMENT] ({ commit, state }, { mnemo, taskId, commentId }) {
    commit(SET_DELETE_TASK_COMMENT_PENDING, taskId)
    try {
      await service.deleteTaskComment(mnemo, taskId, commentId)
    } catch (error) {
      commit(SET_DELETE_TASK_COMMENT_ERROR, error)
      throw error
    } finally {
      commit(REMOVE_DELETE_TASK_COMMENT_PENDING,
        state.deleteTaskCommentPendingIds.indexOf(taskId))
    }
  },
  async [POST_TASK_COMMENT] ({ commit, state }, { mnemo, taskId, data }) {
    commit(SET_POST_TASK_COMMENT_PENDING, taskId)
    try {
      await service.postTaskComment(mnemo, taskId, data)
    } catch (error) {
      commit(SET_POST_TASK_COMMENT_ERROR, error)
      throw error
    } finally {
      commit(REMOVE_POST_TASK_COMMENT_PENDING,
        state.postTaskCommentPendingIds.indexOf(taskId))
    }
  },
  async [GET_TASK_COMMENTS] ({ commit, state }, { mnemo, taskId, params }) {
    commit(SET_TASK_COMMENTS_PENDING, taskId)
    try {
      const response = await service.getTaskComments(mnemo, taskId, params)
      return response.data
    } catch (error) {
      commit(SET_TASK_COMMENTS_ERROR, error)
      throw error
    } finally {
      commit(REMOVE_TASK_COMMENTS_PENDING,
        state.taskCommentsPendingIds.indexOf(taskId))
    }
  },
  async [GET_TASK_STATUS_CATEGORIES] ({ commit }, { mnemo }) {
    commit(SET_TASK_STATUS_CATEGORIES_PENDING, true)
    try {
      const response = await service.getTaskStatuses(mnemo)
      commit(SET_TASK_STATUS_CATEGORIES, response.data.statuses)
    } catch (error) {
      commit(SET_TASK_STATUS_CATEGORIES_ERROR, error)
      throw error
    } finally {
      commit(SET_TASK_STATUS_CATEGORIES_PENDING, false)
    }
  },
  async [EDIT_TASK] ({ commit }, { mnemo, taskId, data }) {
    commit(SET_EDIT_TASK_PENDING, taskId)
    try {
      const response = await service.patchTask(mnemo, taskId, data)
      return response.data
    } finally {
      commit(SET_EDIT_TASK_PENDING, false)
    }
  },
  async [DELETE_SECTION] ({ commit, dispatch }, { mnemo, sectionId }) {
    commit(SET_DELETE_SECTION_PENDING, true)
    try {
      await service.deleteSection(mnemo, sectionId)
      commit(REMOVE_FROM_EXPAND_TASK_AFTER_DELETE, sectionId)
      dispatch(GET_CHECKLIST, mnemo)
    } finally {
      commit(SET_DELETE_SECTION_PENDING, false)
    }
  },
  async [EDIT_SECTION] ({ commit }, { mnemo, sectionId, data }) {
    commit(SET_EDIT_SECTION_PENDING, sectionId)
    try {
      const response = await service.patchSection(mnemo, sectionId, data)
      commit(SET_EDIT_SECTION, response.data)
    } finally {
      commit(SET_EDIT_SECTION_PENDING, false)
    }
  },
  async [CREATE_SECTION] ({ commit, dispatch, state }, { mnemo, data }) {
    commit(SET_CREATE_SECTION_PENDING, true)
    try {
      const response = await service.postSection(mnemo, data)
      trackChecklistCreation(state, mnemo)

      await dispatch(GET_CHECKLIST, mnemo)
      commit(SET_LAST_SECTION_ADDED, response.data)
    } finally {
      commit(SET_CREATE_SECTION_PENDING, false)
    }
  },
  async [CREATE_TASK] ({ commit, dispatch, rootState, state }, { mnemo, data }) {
    commit(SET_CREATE_TASK_PENDING, true)
    try {
      const response = await service.postTask(mnemo, data)
      trackChecklistCreation(state, mnemo)

      await dispatch(GET_CHECKLIST, mnemo)
      commit(SET_LAST_TASK_ADDED, response.data)

      const { id: userId, fullName, email, isSubUser } = rootState.user.profile
      if (surveyCanBeTriggered(SurveyId.CSAT, userId)) {
        triggerSurvey(SurveyId.CSAT, userId, fullName, email, isSubUser)
      }
      if (surveyCanBeTriggered(SurveyId.NPS, userId)) {
        triggerSurvey(SurveyId.NPS, userId, fullName, email, isSubUser)
      }
    } catch (error) {
      commit(SET_CREATE_TASK_ERROR, error)
      throw error
    } finally {
      commit(SET_CREATE_TASK_PENDING, false)
    }
  },
  async [GET_CHECKLIST] ({ commit, dispatch }, mnemo) {
    commit(SET_CHECKLIST_PENDING, true)
    try {
      const { data } = await service.getChecklist(mnemo)

      const { structure, details } = splitChecklistStructureAndDetails(data.todo)

      commit(SET_CHECKLIST_PRISTINE, data.isPristineChecklist)
      commit(SET_CHECKLIST_STRUCTURE, structure)
      commit(SET_CHECKLIST_SECTIONS_DETAILS, details.sections)
      commit(SET_CHECKLIST_TASKS_DETAILS, details.tasks)
      commit(SET_CHECKLIST_LAST_UPDATE_DATE, dayjs().toISOString())

      dispatch(GET_CHECKLIST_DETAILS, mnemo)
    } finally {
      commit(SET_CHECKLIST_PENDING, false)
    }
  },
  async [GET_CHECKLIST_DETAILS] ({ commit }, mnemo) {
    commit(SET_CHECKLIST_DETAILS_PENDING, true)
    try {
      const { data } = await service.getChecklistDetails(mnemo)
      commit(SET_CHECKLIST_TASKS_DETAILS, data)
    } finally {
      commit(SET_CHECKLIST_DETAILS_PENDING, false)
    }
  },
  async [GET_CHECKLIST_LAST_UPDATES] ({ commit, dispatch, state, getters }, { mnemo }) {
    const params = {
      todo: state.checklistStructure,
      timeRef: state.checklistLastUpdateDate,
    }

    const { data } = await service.getChecklistLastUpdates(mnemo, params)

    if (state.checklistItemsBeingEdited.length > 0) {
      return
    }

    const {
      todo,
      created,
      updated,
      timeRef,
      statusChanged,
      isPristineChecklist,
    } = data

    const { details } = splitChecklistStructureAndDetails(todo)
    // Update the details with new positionDisplay and depth 
    const tasksDetails = details.tasks.map(({ id, positionDisplay, depth }) => ({ id, positionDisplay, depth }))
    const sectionsDetails = details.sections.map(({ id, positionDisplay, depth }) => ({ id, positionDisplay, depth }))
    commit(SET_CHECKLIST_SECTIONS_DETAILS, [...sectionsDetails])
    commit(SET_CHECKLIST_TASKS_DETAILS, [...tasksDetails])
    
    commit(SET_CHECKLIST_PRISTINE, isPristineChecklist)
    commit(SET_CHECKLIST_STRUCTURE, todo)
    commit(SET_CHECKLIST_LAST_UPDATE_DATE, timeRef)

    if (created.titles.length > 0 || updated.titles.length > 0) {
      commit(SET_CHECKLIST_SECTIONS_DETAILS, [...created.titles, ...updated.titles])
    }

    if (created.tasks.length > 0 || updated.tasks.length > 0) {
      commit(SET_CHECKLIST_TASKS_DETAILS, [...created.tasks, ...updated.tasks])
    }

    const sectionsDetailsNotPresentInCurrentStructure = Object
      .values(state.checklistDetails.sections)
      .reduce((result, sectionDetails) => {
        if (getters.sections.some(section => section.id === sectionDetails.id) === false) {
          result.push(sectionDetails)
        }

        return result
      }, [])
    if (sectionsDetailsNotPresentInCurrentStructure.length > 0) {
      commit(REMOVE_CHECKLIST_SECTIONS_DETAILS, sectionsDetailsNotPresentInCurrentStructure)
    }

    const tasksDetailsNotPresentInCurrentStructure = Object
      .values(state.checklistDetails.tasks)
      .reduce((result, taskDetails) => {
        if (getters.tasks.some(task => task.id === taskDetails.id) === false) {
          result.push(taskDetails)
        }

        return result
      }, [])
    if (tasksDetailsNotPresentInCurrentStructure.length > 0) {
      commit(REMOVE_CHECKLIST_TASKS_DETAILS, tasksDetailsNotPresentInCurrentStructure)
    }

    if (statusChanged) {
      dispatch(GET_TASK_STATUS_CATEGORIES, { mnemo })
    }
  },
  [OPEN_SAVE_CHECKLIST_DIALOG] ({ commit }) {
    commit(SET_SAVE_CHECKLIST_DIALOG_IS_OPEN, true)
  },
  [CLOSE_SAVE_CHECKLIST_DIALOG] ({ commit }) {
    commit(SET_SAVE_CHECKLIST_DIALOG_IS_OPEN, false)
  },
  [CLOSE_IMPORT_CHECKLIST_DIALOG] ({ commit }) {
    commit(SET_IMPORT_CHECKLIST_DIALOG_IS_OPEN, false)
  },
  [CLOSE_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG] ({ commit }) {
    commit(SET_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG_IS_OPEN, false)
  },
  [OPEN_CHECKLIST_SHARE_BY_EMAIL_PANE] ({ commit }) {
    commit(SET_CHECKLIST_SHARE_BY_EMAIL_PANE, {
      isOpen: true,
      tab: 'share-email',
    })
  },
  [CLOSE_CHECKLIST_SHARE_BY_EMAIL_PANE] ({ commit }) {
    commit(SET_CHECKLIST_SHARE_BY_EMAIL_PANE, {
      isOpen: false,
      tab: '',
    })
  },
  async [SHARE_CHECKLIST_BY_EMAIL] ({ commit }, { mnemo, data }) {
    commit(SET_SHARE_CHECKLIST_BY_EMAIL_PENDING, true)

    try {
      await service.shareChecklistByEmail(mnemo, data)
    } finally {
      commit(SET_SHARE_CHECKLIST_BY_EMAIL_PENDING, false)
    }
  },
  [ADD_TASK_TO_SELECTION] ({ commit, getters }, task) {
    const taskIsAlreadySelected = getters.selectedTasks.some(selectedTask => selectedTask.id === task.id)

    if (taskIsAlreadySelected) {
      return
    }

    const selectedTasks = [...getters.selectedTasks, task]
    commit(SET_SELECTED_TASKS, selectedTasks)
  },
  [REMOVE_TASK_FROM_SELECTION] ({ commit, getters }, task) {
    const taskIsAlreadySelected = getters.selectedTasks.some(selectedTask => selectedTask.id === task.id)

    if (taskIsAlreadySelected) {
      const selectedTasks = getters.selectedTasks.filter(selectedTask => selectedTask.id !== task.id)
      commit(SET_SELECTED_TASKS, selectedTasks)
    }
  },
  [ADD_SECTION_TO_SELECTION] ({ commit, getters }, section) {
    const sectionIsAlreadySelected = getters.selectedSections.some(selectedSection => selectedSection.id === section.id)

    if (sectionIsAlreadySelected) {
      return
    }

    const selectedSections = [...getters.selectedSections, section]
    commit(SET_SELECTED_SECTIONS, selectedSections)
  },
  [REMOVE_SECTION_FROM_SELECTION] ({ commit, getters }, section) {
    const sectionIsNotSelected = !getters.selectedSections.some(selectedSection => selectedSection.id === section.id)

    if (sectionIsNotSelected) {
      return
    }

    const selectedSections = getters.selectedSections.filter(selectedSection => selectedSection.id !== section.id)
    commit(SET_SELECTED_SECTIONS, selectedSections)
  },
  [ADD_SECTION_CHILDREN_TO_SELECTION] ({ commit, dispatch, getters }, section) {
    const childrenTasksNotSelectedYet = section.children.filter(
      child => child.type === 'task' &&
        getters.filteredTasks.some(task => task.id === child.id) &&
        !getters.selectedTasks.some(task => task.id === child.id),
    )

    if (childrenTasksNotSelectedYet.length > 0) {
      const selectedTasks = [].concat(getters.selectedTasks, childrenTasksNotSelectedYet)
      commit(SET_SELECTED_TASKS, selectedTasks)
    }

    const childrenSectionsNotSelectedYet = section.children.filter(
      child => child.type === 'title' &&
      (!getters.isChecklistFiltered || getters.filteredSections.some(filteredSection => filteredSection.id === child.id)) &&
        !getters.selectedSections.some(selectedSection => selectedSection.id === child.id),
    )

    childrenSectionsNotSelectedYet.forEach(childrenSection => {
      dispatch(ADD_SECTION_TO_SELECTION, childrenSection)
      dispatch(ADD_SECTION_CHILDREN_TO_SELECTION, childrenSection)
    })
  },
  [REMOVE_SECTION_CHILDREN_FROM_SELECTION] ({ commit, dispatch, getters }, section) {
    const childrenTasksAlreadySelected = section.children.filter(
      child => child.type === 'task' && getters.selectedTasks.some(task => task.id === child.id),
    )

    if (childrenTasksAlreadySelected.length > 0) {
      const selectedTasks = getters.selectedTasks.filter(
        task => !childrenTasksAlreadySelected.some(child => child.id === task.id),
      )
      commit(SET_SELECTED_TASKS, selectedTasks)
    }

    const childrenSectionsAlreadySelected = section.children.filter(
      child => child.type === 'title' && getters.selectedSections.some(selectedSection => selectedSection.id === child.id),
    )
    childrenSectionsAlreadySelected.forEach(childrenSection => {
      dispatch(REMOVE_SECTION_FROM_SELECTION, childrenSection)
      dispatch(REMOVE_SECTION_CHILDREN_FROM_SELECTION, childrenSection)
    })
  },
  [CLEAR_ITEMS_SELECTION] ({ commit }) {
    commit(SET_SELECTED_TASKS, [])
    commit(SET_SELECTED_SECTIONS, [])
  },
  [ADD_ALL_ITEMS_TO_SELECTION] ({ commit, getters }) {
    const selectableTasks = getters.isChecklistFiltered ? getters.filteredTasks : getters.tasks
    const selectableSections = getters.isChecklistFiltered ? getters.filteredSections : getters.sections

    commit(SET_SELECTED_TASKS, selectableTasks)
    commit(SET_SELECTED_SECTIONS, selectableSections.filter(section => section.id !== 0))
  },
  [EXPAND_SECTION] ({ commit, state }, sectionId) {
    const sectionsExpandState = state.sectionsExpandState
      .filter(sectionExpandState => sectionExpandState.id !== sectionId)
      .concat({ id: sectionId, value: true })

    commit(SET_SECTIONS_EXPAND_STATE, sectionsExpandState)
  },
  [EXPAND_ALL_SECTIONS] ({ commit, getters }) {
    const sectionsExpandState = getters.sections.map(section => ({
      id: section.id,
      value: true,
    }))

    commit(SET_SECTIONS_EXPAND_STATE, sectionsExpandState)
  },
  [COLLAPSE_SECTION] ({ commit, state }, sectionId) {
    const sectionsExpandState = state.sectionsExpandState
      .filter(sectionExpandState => sectionExpandState.id !== sectionId)
      .concat({ id: sectionId, value: false })

    commit(SET_SECTIONS_EXPAND_STATE, sectionsExpandState)
  },
  [COLLAPSE_ALL_SECTIONS] ({ commit, getters }) {
    const sectionsExpandState = getters.sections.map(section => ({
      id: section.id,
      value: false,
    }))

    commit(SET_SECTIONS_EXPAND_STATE, sectionsExpandState)
  },
  [DELETE_SEARCH_RESULTS] ({ commit }) {
    commit(SET_SEARCH_QUERY, [])
    commit(SET_SELECTED_TASKS, [])
  },
  [GET_SEARCH_RESULTS] ({ commit }, searchQuery) {
    const searchQueryArray = searchQuery.trim().split(' ')
    commit(SET_SEARCH_QUERY, searchQueryArray)
    commit(SET_SELECTED_TASKS, [])
  },
  [CHANGE_CHECKLIST_VERSIONING_PANE_TAB] ({ commit }, tab) {
    commit(SET_CHECKLIST_VERSIONING_PANE_TAB, tab)
  },
  [CLOSE_CHECKLIST_VERSIONING_PANE] ({ commit }) {
    commit(TOGGLE_CHECKLIST_VERSIONING_PANE, {
      documentVersions: [],
      documents: [],
      isOpen: false,
      tab: null,
    })
  },
  [SET_CHECKLIST_VERSIONING_PANE] ({ commit }, payload) {
    commit(TOGGLE_CHECKLIST_VERSIONING_PANE, payload)
  },
  [CHANGE_CHECKLIST_PANE_TASKS] ({ commit }, tasks) {
    commit(SET_CHECKLIST_PANE_TASKS, tasks)
  },
  [CHANGE_CHECKLIST_PANE_TAB] ({ commit }, tab) {
    commit(SET_CHECKLIST_PANE_TAB, tab)
  },
  [CLOSE_CHECKLIST_PANE] ({ commit }) {
    commit(SET_CHECKLIST_PANE, {
      isOpen: false,
      tab: null,
      tasks: [],
    })
  },
  [OPEN_CHECKLIST_PANE] ({ commit }, payload) {
    commit(SET_CHECKLIST_PANE, payload)
  },
  async [GET_PANE_TASK_DETAILS] ({ commit, state }, { mnemo, taskId }) {
    commit(SET_PANE_TASK_DETAILS_PENDING, taskId)
    try {
      const response = await service.getPaneTaskDetails(mnemo, taskId)
      return response.data
    } finally {
      commit(REMOVE_PANE_TASK_DETAILS_PENDING,
        state.paneTaskDetailsPendingIds.indexOf(taskId))
    }
  },
  async [UPDATE_TASK_RIGHTS] ({ commit, state }, { mnemo, task, data }) {
    commit(SET_TASK_RIGHTS_PENDING, task.id)
    try {
      const response = await service.updateTaskRights(mnemo, task.id, data)
      task.rights = response.data
      commit(SET_EDIT_TASK, task)
    } finally {
      commit(REMOVE_TASK_RIGHTS_PENDING,
        state.taskRightsPendingIds.indexOf(task.id))
    }
  },
}
